/**
 * Color utility functions for highlights
 */

/**
 * Convert hex color to rgba with transparency
 * @param hex - Hex color string (e.g., "#FFEB3B")
 * @param alpha - Alpha value (0-1), defaults to 0.4 for readable highlights
 * @returns rgba color string
 */
export function hexToRgba(hex: string, alpha: number = 0.4): string {
  // Remove # if present
  hex = hex.replace('#', '');

  // Parse hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * Get semi-transparent version of highlight color
 * Used for PDF and HTML rendering where text must remain visible
 * @param color - Solid color hex string
 * @returns Semi-transparent rgba color
 */
export function getTransparentHighlightColor(color: string): string {
  return hexToRgba(color, 0.35); // 35% opacity - text remains clearly visible
}
